import React from 'react'
import PropTypes from 'prop-types'
import { CAlert } from '@coreui/react-pro'
import { getApiErrorMessage } from '../utils/apiErrors'
import RetryButton from './RetryButton'

const PageError = ({
  error,
  fallback = 'Не удалось загрузить данные.',
  onRetry,
  className = 'mb-0',
}) => {
  const message = getApiErrorMessage(error, fallback)

  return (
    <CAlert color="danger" className={className}>
      <div className="d-flex flex-wrap align-items-center gap-2">
        <span>{message}</span>
        <RetryButton onClick={onRetry} color="danger" className="ms-auto" />
      </div>
    </CAlert>
  )
}

PageError.propTypes = {
  error: PropTypes.any,
  fallback: PropTypes.string,
  onRetry: PropTypes.func,
  className: PropTypes.string,
}

export default PageError
